import { useState } from "react";
import {
  Wrapper,
  Label,
  InputField,
  SelectField,
  WrapperDropDown,
  EyeIcon,
  WrapperPhoneDropDown,
  SelectPhoneField,
} from "./text-field.styles";
import Eyesecurity from "../../assets/icons/eye-close-security.png";
import { InfoCircle } from "../../../public/assets";
import { FiEye, FiEyeOff } from "react-icons/fi";

interface TextFieldsProps {
  label?: string;
  value: string;
  width?: string;
  height?: string;
  fontSize?: string;
  onChange: (value: any) => any;
  name?: any;
  placeholder?: string;
  type: string;
  id?: string;
  color?: string;
  icon?: string;
  showIcon?: boolean;
  autoComplete?: string;
  [key: string]: any;
}

const TextFields: React.FC<TextFieldsProps> = ({
  label,
  value,
  onChange,
  name,
  placeholder,
  fontSize,
  type,
  width,
  height,
  id,
  showIcon,
  color,
  autoComplete,

  icon,
  ...props
}) => {
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };
  const togglePasswordVisibility = () => {
    setPasswordVisibility(!passwordVisibility);
  };
  return (
    <Wrapper style={{ height }}>
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
      >
        <Label htmlFor={label}>{label}</Label>
        {showIcon && (
          <img
            src="/assets/svg/info-circle.svg"
            alt=""
            style={{ paddingLeft: "10px" }}
          />
        )}
      </div>
      <InputField
        type={passwordVisibility ? "text" : type}
        placeholder={placeholder}
        id={label}
        width={width}
        name={name}
        style={{ fontSize, height, color: color }}
        value={value}
        fontSize={fontSize}
        onChange={handleChange}
        autoComplete={autoComplete}
        {...props}
      />
      {type === "password" && (
        <EyeIcon>
          {passwordVisibility ? (
            <FiEye onClick={togglePasswordVisibility} />
          ) : (
            <FiEyeOff onClick={togglePasswordVisibility} />
          )}
        </EyeIcon>
      )}
    </Wrapper>
  );
};

export default TextFields;

interface TextFieldsDropDownProps {
  label?: string;
  value: string;
  width?: string;
  height?: string;
  border?: string;
  borderRadius?: string;
  onChange: (value: string) => void;
  placeholder: string;
  options: { value: string; label: string }[];
}

export const DropDownTextField: React.FC<TextFieldsDropDownProps> = ({
  label,
  value,
  onChange,
  placeholder,
  options,
  width,
  height,
  borderRadius,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };
  return (
    <WrapperDropDown>
      <Label htmlFor={label}>{label}</Label>
      <SelectField
        id={label}
        value={value}
        onChange={handleChange}
        width={width}
      >
        <option value="" disabled hidden>
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </SelectField>
    </WrapperDropDown>
  );
};
